/* Article body promo injection.
 *
 * Walks the article's rich-text body and appends a Recipe Kit closing card
 * (Pantry Pulse subscribe cards were removed 2026-09-26)
 * at the end. The HTML templates are rendered server-side by Liquid into two
 * <template> elements so we don't duplicate copy here. */

(function () {
  'use strict';

  function pickSubscribeCount(paragraphCount) {
    // One Pantry Pulse card in the body at most; the closing Recipe Kit card
    // still appends at the end. More than one subscribe insert reads as
    // aggressive, especially on long case studies.
    if (paragraphCount < 5) return 0;
    return 1;
  }

  function isQuestionParagraph(p) {
    // Q&A prompts render as a <p> whose bold text ends in a question mark.
    // A promo card must never land between one of these and the answer below.
    if (!p) return false;
    var t = p.textContent.trim();
    return p.querySelector('strong') != null && t.charAt(t.length - 1) === '?';
  }

  function evenlySpacedIndexes(paragraphCount, cardCount) {
    // Divide the body into (cardCount + 1) regions and put a card at each
    // boundary that lands AFTER a paragraph, not right at the start.
    if (cardCount <= 0) return [];
    var spots = [];
    for (var i = 1; i <= cardCount; i++) {
      var pIdx = Math.round((paragraphCount * i) / (cardCount + 1));
      // Clamp away from the very first paragraph so we don't kneecap the intro.
      if (pIdx < 1) pIdx = 1;
      if (pIdx >= paragraphCount) pIdx = paragraphCount - 1;
      spots.push(pIdx);
    }
    return spots;
  }

  function cloneTemplate(tpl) {
    if (!tpl || !tpl.content) return null;
    var frag = tpl.content.cloneNode(true);
    // Templates wrap content in a fragment; return the first element child.
    return frag.firstElementChild || frag;
  }

  function findParagraphAnchors(content) {
    // Preferred: explicit <p> tags in the content tree.
    var paragraphs = Array.prototype.filter.call(
      content.querySelectorAll('p'),
      function (el) {
        // Only anchor to top-level body paragraphs. Never a <p> nested inside a
        // blockquote, list, figure, or the stats bar — inserting there drops the
        // promo card into the middle of a pull-quote or list and breaks layout.
        return el.textContent.trim().length > 40
          && content.contains(el)
          && !el.closest('blockquote, li, figure, .rk-case-stats, .rk-pullquote, .rk-quote');
      }
    );
    if (paragraphs.length) return paragraphs;

    // Fallback: split loose text nodes on blank lines and wrap each chunk in a
    // <p> so we have stable anchors to insert next to.
    var textNodes = [];
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim().length > 80) textNodes.push(node);
    }
    var wrapped = [];
    textNodes.forEach(function (textNode) {
      if (!textNode.parentNode) return;
      var chunks = textNode.textContent.split(/\n\s*\n+/);
      if (chunks.length <= 1) return;
      var frag = document.createDocumentFragment();
      chunks.forEach(function (chunk) {
        var trimmed = chunk.trim();
        if (!trimmed) return;
        var p = document.createElement('p');
        p.textContent = trimmed;
        frag.appendChild(p);
        wrapped.push(p);
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return wrapped;
  }

  function injectInto(content) {
    // Pantry Pulse subscribe cards removed 2026-09-26 (newsletter not launched).
    // Only the Recipe Kit closing card is appended now.
    var appTpl = document.getElementById('rk-promo-app-template');
    if (!appTpl) return;

    var paragraphs = findParagraphAnchors(content);

    // Append the Recipe Kit closing card only on long-enough articles. On stub
    // recipe posts (1–4 short paragraphs) it dominates the layout and lands
    // right before the recipe widget — and the bottom rk-cta-final already
    // makes the same pitch.
    if (paragraphs.length >= 5) {
      var closer = cloneTemplate(appTpl);
      if (closer) content.appendChild(closer);
    }
  }

  function init() {
    var content = document.querySelector('.rk-article__content');
    if (!content) return;
    injectInto(content);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
